import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColumnChart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1553 10.1478H12.272C12.6711 10.1478 12.9927 10.4472 12.9927 10.8014V19.9838H14.3528V13.9043C14.3528 13.5469 14.6707 13.2505 15.0735 13.2505H15.1903C15.5931 13.2505 15.911 13.5469 15.911 13.9043V19.9838H21.3294C22.2235 19.9838 22.2235 21.2001 21.3294 21.2001H2.67992C2.30466 21.2001 2 20.9277 2 20.5919V20.3043V1.60813C2 1.27249 2.30452 1 2.67992 1C3.05518 1 3.35985 1.27237 3.35985 1.60813V19.984H5.59865V5.17596C5.59865 4.81863 5.91657 4.52216 6.31939 4.52216H6.43613C6.83895 4.52216 7.15686 4.81863 7.15686 5.17596V19.984H8.51691V7.36802C8.51691 7.01069 8.83483 6.71423 9.23765 6.71423H9.35439C9.75722 6.71423 10.0751 7.01069 10.0751 7.36802V19.984H11.435V10.793C11.4399 10.4423 11.7603 10.1478 12.1553 10.1478Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgColumnChart;
